import React, { useContext, useState } from "react";
import { ASSETS_BASE_URL } from "../../../AppConstants/Constants";
import styles from "./index.module.scss";
import { showToast } from "../../../utils/common.utils";
import { AnalyticsContext } from "../../../contexts/Analytics/AnalyticsContextProvider";
import { PRIVATE_CONTENT_VERIFY } from "../../../AppConstants/AnalyticsEventName";

import LoaderImg from "../../../assets/images/Loader.gif";
import { globalsAPI } from "../../../apis/globalsAPI";

const closeIcon = `${ASSETS_BASE_URL}/images/close.png`;

const PrivateVideoVerificationModal = ({
  verificationModal,
  handleClose,
  handleVerifyButton,
  collection,
  creteUserDoc,
  showBackgroundBlur = false,
}) => {
  const { addGAWithUserInfo } = useContext(AnalyticsContext);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    try {
      if (e) {
        e.preventDefault();
      }
      let obj = {};
      let formSelector = Array.from(
        document.querySelectorAll(`#academyPrivateForm input`)
      );

      if (formSelector && formSelector.length) {
        for (const iterator of formSelector) {
          if (
            (!iterator.value || !iterator.value.trim()) &&
            iterator.required
          ) {
            showToast(`Please enter valid ${iterator.name}.`);
            return;
          }
          obj[iterator.name] = iterator.value;
        }
      }
      setLoading(true);
      if (verificationModal.data.isUnlockedForUser) {
        await verifyAcademyUser(obj["privateCodeAcademy"]);
      }
      if (verificationModal.data.prerequisite) {
        handlePreRequisiteForm(obj, (cb) => {
          if (cb) {
            handleVerifyButton();
            setLoading(false);
          }
        });
      } else {
        handleVerifyButton();
        setLoading(false);
      }
    } catch (error) {
      const { data: err } = error;
      setLoading(false);
      showToast(err?.message || "Some internal error ocurred.");
    }
  };

  const verifyAcademyUser = async (privateCodeAcademy) => {
    let res = await globalsAPI.privateCodeValidation({
      code: privateCodeAcademy,
      type: collection,
      targetId: verificationModal?.data?.courseData?.id,
    });

    if (res) {
      addGAWithUserInfo(PRIVATE_CONTENT_VERIFY, {
        eventId: verificationModal?.data?.courseData?.id,
        type: collection,
        ...verificationModal?.data.courseData,
      });
    } else {
      setLoading(false);
    }
  };

  const handlePreRequisiteForm = (data, cb2 = () => {}) => {
    creteUserDoc((cb) => {
      if (cb) {
        cb2(cb);
      }
    }, data);
  };

  return (
    <>
      <div
        onClick={handleClose}
        className={
          verificationModal.open
            ? `${
                showBackgroundBlur
                  ? "modalOverlayWithBlur"
                  : "modalOverlayWithTint"
              }`
            : ""
        }
      />
      <div
        className={`${styles.container} ${
          verificationModal.open ? styles.fadeIn : ""
        } ${showBackgroundBlur ? styles.withBlur : ""}`}
      >
        <div className={styles.body}>
          <div className={styles.heading}>
            {verificationModal.data.isUnlockedForUser
              ? "Enter Verification Code"
              : "Enter details"}
          </div>
          <div className={styles.slotsContainer}>
            {verificationModal.data.courseData && (
              <form
                id="academyPrivateForm"
                onSubmit={handleSubmit}
                style={{ width: "100%" }}
              >
                {verificationModal.data.isUnlockedForUser && (
                  <>
                    <div
                      className={`${styles["inputContainer"]} input-group`}
                      style={{ marginBottom: "0.8rem" }}
                    >
                      <label htmlFor={"privateCodeAcademy"}>
                        Verification Code
                      </label>
                      <input
                        id={"privateCodeAcademy"}
                        name={"privateCodeAcademy"}
                        className={"form-control"}
                        placeholder={"Please enter verification code."}
                        type={"text"}
                        required={true}
                        disabled={loading}
                      />
                    </div>

                    <div className={styles.disclaimer}>
                      {verificationModal?.data?.courseData?.disclaimer
                        ? verificationModal?.data?.courseData?.disclaimer
                        : "* Please connect with mankind field representative."}
                    </div>
                  </>
                )}
                {verificationModal.data.courseData?.prerequisite?.map(
                  (prerequisite, index) => {
                    return (
                      <div
                        key={index}
                        className={`${styles["inputContainer"]} input-group`}
                        style={{ marginBottom: "0.8rem" }}
                      >
                        <label htmlFor={prerequisite["fieldName"]}>
                          {prerequisite["label"]}{" "}
                          {!prerequisite["required"] && "(optional)"}
                        </label>
                        <input
                          id={prerequisite["fieldName"]}
                          name={prerequisite["fieldName"]}
                          className={"form-control"}
                          placeholder={prerequisite["placeholder"]}
                          type={prerequisite["fieldTypeWeb"]}
                          required={prerequisite["required"]}
                          disabled={loading}
                        />
                      </div>
                    );
                  }
                )}

                <button
                  type="submit"
                  className={`btn ${styles["submit-btn"]}`}
                  disabled={loading}
                >
                  {loading ? (
                    <img src={LoaderImg} alt="" height="100%" />
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            )}
          </div>

          <div onClick={handleClose} className={styles.closeBtn}>
            <img src={closeIcon} alt="Close" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivateVideoVerificationModal;
